import React from 'react';
import PropTypes from 'prop-types';

import { Avatar } from '@material-ui/core';
import useGlobalStore from '../../store/globalStore';

const handleAcronymImage = ({ user, width, height }) => {
  try {
    return (
      <Avatar
        style={{
          width: width ?? 38,
          height: height ?? 38,
          background: 'rgb(31, 108, 250)',
        }}
      >
        {user?.firstName.substring(0, 2)}
      </Avatar>
    );
  } catch (error) {
    return (
      <Avatar
        style={{
          width: width ?? 38,
          height: height ?? 38,
          background: 'rgb(31, 108, 250)',
        }}
      >
        CR
      </Avatar>
    );
  }
};

export default function UserAvatar({ width, height }) {
  const user = useGlobalStore((state) => state.general.user);
  return user.imageUrl ? (
    <Avatar
      src={user.imageUrl}
      style={{ width: width ?? 38, height: height ?? 38 }}
      alt="Foto perfil"
    />
  ) : (
    handleAcronymImage({ user, width, height })
  );
}

UserAvatar.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};
